export default __webpack_public_path__ + "static/media/ping.ee576941.mp3";